module.exports = __webpack_public_path__ + "static/img/mood2.69c087e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood2.png
// module id = U0VO
// module chunks = 1